import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-links">
        <Link to="/privacy" className="site-footer-link">Privacy Policy</Link>
        <span className="site-footer-dot">·</span>
        <Link to="/terms" className="site-footer-link">Terms of Service</Link>
        <span className="site-footer-dot">·</span>
        <Link to="/contact" className="site-footer-link">Contact Us</Link>
      </div>
      <div className="site-footer-copy">© {new Date().getFullYear()} TradeReady Pro</div>
    </footer>
  );
}

export default Footer;
